import { toastBus } from "@/features/toast/toastBus"
import type { ToastInput, ToastSeverity } from "@/features/toast/types"

type ShortInput = Omit<ToastInput, "severity">

const make = (severity: ToastSeverity) => (input: ShortInput | string) => {
  if (typeof input === "string") {
    toastBus.publish({ severity, title: input })
    return
  }
  toastBus.publish({ ...input, severity })
}

export const toast = {
  success: make("success"),
  error: make("error"),
  custom(input: ToastInput) {
    toastBus.publish(input)
  },
}
